// Redux action creators for Credit App
import { SUBMIT_CREDIT_APP, INITIALIZE_CREDIT_APP, RESET_CREDIT_APP } from './actions';
import type { CreditAppShopper } from '@makemydeal/dr-sales-checkin-store';
import type { GenericObject } from '@makemydeal/dr-platform-types';

// Initialize credit app state from external data
export const initializeCreditApp = (creditAppData: GenericObject, dealRefId?: string) => ({
    type: INITIALIZE_CREDIT_APP,
    payload: {
        creditApp: creditAppData,
        dealRefId
    }
});

// Reset credit app state to initial values
export const resetCreditApp = () => ({
    type: RESET_CREDIT_APP,
    payload: {}
});

// Mark credit app as submitted
export const submitCreditApp = (creditAppId: string, dealRefId: string, shopper?: CreditAppShopper) => ({
    type: SUBMIT_CREDIT_APP,
    payload: {
        creditAppId,
        dealRefId,
        shopper
    }
});
